export enum MeetingAuthenticationTypeEnum {
  EMAIL = "email",
  SMS = "sms",
}

export const MEETING_AUTHENTICATION_TYPE_VALUES = Object.values(
  MeetingAuthenticationTypeEnum,
) as string[];

export const DEFAULT_MEETING_AUTHENTICATION_TYPES: MeetingAuthenticationTypeEnum[] = [
  MeetingAuthenticationTypeEnum.EMAIL,
  MeetingAuthenticationTypeEnum.SMS,
];

export function resolveAllowedAuthenticationTypes(
  value: string[] | undefined | null,
): MeetingAuthenticationTypeEnum[] {
  if (!value?.length) {
    return [...DEFAULT_MEETING_AUTHENTICATION_TYPES];
  }

  const allowed = new Set(MEETING_AUTHENTICATION_TYPE_VALUES);
  const resolved = value.filter(
    (type): type is MeetingAuthenticationTypeEnum =>
      typeof type === "string" && allowed.has(type),
  );

  return resolved.length > 0 ? resolved : [...DEFAULT_MEETING_AUTHENTICATION_TYPES];
}

export function isMeetingAuthenticationChannelAllowed({
  channel,
  allowedTypes,
}: {
  channel: "email" | "phone";
  allowedTypes: MeetingAuthenticationTypeEnum[];
}): boolean {
  if (channel === "email") {
    return allowedTypes.includes(MeetingAuthenticationTypeEnum.EMAIL);
  }
  return allowedTypes.includes(MeetingAuthenticationTypeEnum.SMS);
}
